import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faAddressCard,
  faAlarmClock,
  faAlignJustify,
  faAnchor,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowDownToBracket,
  faArrowFromLeft,
  faArrowLeft,
  faArrowPointer,
  faArrowRight,
  faArrowToRight,
  faArrowsAlt,
  faArrowsV,
  faAsterisk,
  faAt,
  faBadgeDollar,
  faBadgePercent,
  faBalanceScale,
  faBallotCheck,
  faBan,
  faBars,
  faBell,
  faBook,
  faBookOpen,
  faBookSpells,
  faBookmark,
  faBoxUsd,
  faBrackets,
  faBriefcase,
  faBuilding,
  faCalculator,
  faCalendarAlt,
  faCalendarDays,
  faCalendarTimes,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDoubleRight,
  faChevronLeft,
  faChevronRight,
  faChimney,
  faClipboardList,
  faClipboardListCheck,
  faClock,
  faClone,
  faCloudUpload,
  faCog,
  faColumns,
  faCommentAltCheck,
  faCommentAltLines,
  faComments,
  faCommentsAlt,
  faCopy,
  faCreditCardFront,
  faCreditCard,
  faCrown,
  faDiscDrive,
  faDollarSign,
  faDownload,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEngineWarning,
  faEquals,
  faEuroSign,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileCertificate,
  faFileCheck,
  faFileContract,
  faFileEdit,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMedical,
  faFileTimes,
  faFilesMedical,
  faFillDrip,
  faFilter,
  faFlagAlt,
  faFolder,
  faFolderOpen,
  faFolderTree,
  faFolders,
  faFontCase,
  faGift,
  faGlasses,
  faGlobe,
  faGripLines,
  faGripLinesVertical,
  faHashtag,
  faHdd,
  faHeartRate,
  faHome,
  faHourglassHalf,
  faImage,
  faImages,
  faInbox,
  faInboxIn,
  faInfoCircle,
  faInfoSquare,
  faInputNumeric,
  faInputText,
  faKey,
  faLayerGroup,
  faLayerPlus,
  faLink,
  faList,
  faListAlt,
  faListCheck,
  faListOl,
  faListRadio,
  faListUl,
  faLock,
  faMapMarkerAlt,
  faMicroscope,
  faMinus,
  faMoneyBillWave,
  faMoneyCheckAlt,
  faMoneyCheckEdit,
  faNetworkWired,
  faObjectGroup,
  faObjectUngroup,
  faPageBreak,
  faPalette,
  faPaperPlane,
  faPaperclip,
  faParagraph,
  faPen,
  faPenSquare,
  faPencilAlt,
  faPenToSquare,
  faPercentage,
  faPhoneAlt,
  faPlug,
  faPlus,
  faPlusCircle,
  faPoundSign,
  faPrint,
  faPuzzlePiece,
  faQuestionCircle,
  faRedo,
  faReply,
  faRobot,
  faRoute,
  faRupeeSign,
  faSackDollar,
  faSave,
  faSearch,
  faShapes,
  faShare,
  faShareAlt,
  faShareSquare,
  faShieldAlt,
  faShieldCheck,
  faShoppingCart,
  faSignInAlt,
  faSignal,
  faSignature,
  faSlidersH,
  faSort,
  faSortAmountDown,
  faSortAmountUp,
  faSpinner,
  faSquare,
  faSquareCheck,
  faSquareM,
  faSyncAlt,
  faTable,
  faTag,
  faTags,
  faTextHeight,
  faThumbsDown,
  faTilde,
  faTimes,
  faTimesCircle,
  faTimesHexagon,
  faTrashAlt,
  faTrophyAlt,
  faUndo,
  faUnlock,
  faUpload,
  faUser,
  faUserCheck,
  faUserCircle,
  faUserCog,
  faUserFriends,
  faUserNinja,
  faUserPlus,
  faUserTag,
  faUsers,
  faVideo,
  faYenSign,
  faSplit,
} from "@fortawesome/pro-regular-svg-icons";

export default library.add(
  faAddressCard,
  faAlarmClock,
  faAlignJustify,
  faAnchor,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowDownToBracket,
  faArrowFromLeft,
  faArrowLeft,
  faArrowPointer,
  faArrowRight,
  faArrowToRight,
  faArrowsAlt,
  faArrowsV,
  faAsterisk,
  faAt,
  faBadgeDollar,
  faBadgePercent,
  faBalanceScale,
  faBallotCheck,
  faBan,
  faBars,
  faBell,
  faBook,
  faBookOpen,
  faBookSpells,
  faBookmark,
  faBoxUsd,
  faBrackets,
  faBriefcase,
  faBuilding,
  faCalculator,
  faCalendarAlt,
  faCalendarDays,
  faCalendarTimes,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDoubleRight,
  faChevronLeft,
  faChevronRight,
  faChimney,
  faClipboardList,
  faClipboardListCheck,
  faClock,
  faClone,
  faCloudUpload,
  faCog,
  faColumns,
  faCommentAltCheck,
  faCommentAltLines,
  faComments,
  faComments,
  faCommentsAlt,
  faCopy,
  faCreditCardFront,
  faCreditCard,
  faCrown,
  faDiscDrive,
  faDollarSign,
  faDownload,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEngineWarning,
  faEquals,
  faEuroSign,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileCertificate,
  faFileCheck,
  faFileContract,
  faFileEdit,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMedical,
  faFileTimes,
  faFilesMedical,
  faFillDrip,
  faFilter,
  faFlagAlt,
  faFolder,
  faFolderOpen,
  faFolderTree,
  faFolders,
  faFontCase,
  faGift,
  faGlasses,
  faGlobe,
  faGripLines,
  faGripLinesVertical,
  faHashtag,
  faHdd,
  faHeartRate,
  faHome,
  faHourglassHalf,
  faImage,
  faImages,
  faInbox,
  faInboxIn,
  faInfoCircle,
  faInfoSquare,
  faInputNumeric,
  faInputText,
  faKey,
  faLayerGroup,
  faLayerPlus,
  faLink,
  faList,
  faListAlt,
  faListCheck,
  faListOl,
  faListRadio,
  faListUl,
  faLock,
  faMapMarkerAlt,
  faMicroscope,
  faMinus,
  faMoneyBillWave,
  faMoneyCheckAlt,
  faMoneyCheckEdit,
  faNetworkWired,
  faObjectGroup,
  faObjectUngroup,
  faPageBreak,
  faPalette,
  faPaperPlane,
  faPaperclip,
  faParagraph,
  faPen,
  faPenSquare,
  faPencilAlt,
  faPenToSquare,
  faPercentage,
  faPhoneAlt,
  faPlug,
  faPlus,
  faPlusCircle,
  faPoundSign,
  faPrint,
  faPuzzlePiece,
  faQuestionCircle,
  faRedo,
  faReply,
  faRobot,
  faRoute,
  faRupeeSign,
  faSackDollar,
  faSave,
  faSearch,
  faShapes,
  faShare,
  faShareAlt,
  faShareSquare,
  faShieldAlt,
  faShieldCheck,
  faShoppingCart,
  faSignInAlt,
  faSignal,
  faSignature,
  faSlidersH,
  faSort,
  faSortAmountDown,
  faSortAmountUp,
  faSpinner,
  faSquare,
  faSquareCheck,
  faSquareM,
  faSyncAlt,
  faTable,
  faTag,
  faTags,
  faTextHeight,
  faThumbsDown,
  faTilde,
  faTimes,
  faTimesCircle,
  faTimesHexagon,
  faTrashAlt,
  faTrophyAlt,
  faUndo,
  faUnlock,
  faUpload,
  faUser,
  faUserCheck,
  faUserCircle,
  faUserCog,
  faUserFriends,
  faUserNinja,
  faUserPlus,
  faUserTag,
  faUsers,
  faVideo,
  faYenSign,
  faSplit,
);
